module.exports = __webpack_public_path__ + "fa-regular-400.svg?d2e53334c22a9a4937bc26e84b36e1e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fa-regular-400.svg
// module id = 52
// module chunks = 0